import { render } from "./DetailsContentPage.vue?vue&type=template&id=58f4cfa2"
import script from "./DetailsContentPage.vue?vue&type=script&lang=js"
export * from "./DetailsContentPage.vue?vue&type=script&lang=js"

import "./DetailsContentPage.vue?vue&type=style&index=0&id=58f4cfa2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__